'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCellValue = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isValidNumber = R.both(R.is(Number), R.complement(R.equals(NaN)));

var getCellValue = exports.getCellValue = function getCellValue(observation) {
  var value = R.prop('value', observation);
  if (R.is(Boolean, value)) {
    return value;
  }
  if (R.is(String, value)) {
    var monthMatch = value.match(/^\-\-([\d]{2})$/);
    if (R.is(Array, monthMatch)) {
      return R.nth(1, monthMatch);
    }
    var monthDayMatch = value.match(/^\-\-([\d]{2}\-[\d]{2})$/);
    if (R.is(Array, monthDayMatch)) {
      return R.nth(1, monthDayMatch);
    }
    var dayMatch = value.match(/^\-\-\-([\d]{2})$/);
    if (R.is(Array, dayMatch)) {
      return R.nth(1, dayMatch);
    }
    return value;
  }
  var scale = Number(observation.prefscale);
  var formatScale = R.ifElse(R.always(isValidNumber(scale)), function (value) {
    return (0, _numeral2.default)(value).multiply(Math.pow(10, -1 * Number(scale))).value();
  }, R.identity);
  var formatSeparator = function formatSeparator(value) {
    return (0, _numeral2.default)(value).format('0,0.[0000000]');
  };
  var decimals = Number(observation.decimals);
  var formatDecimals = R.ifElse(R.always(isValidNumber(decimals)), function (value) {
    return (0, _numeral2.default)(value).format(R.ifElse(R.equals(0), R.always('0,0'), function (d) {
      return '0,0.' + R.join('', R.times(R.always('0'), d));
    })(decimals));
  }, formatSeparator);
  var res = R.ifElse(isValidNumber, R.pipe(formatScale, formatDecimals), R.always('..'))(observation.value);
  return res;
};